import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheVaultEntrance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-vault-entrance" ref={ref} className="dark bg-background text-foreground relative min-h-[90vh] w-full overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/blueprint_pattern.png')] bg-repeat bg-[length:400px_400px] animate-[background-scroll_60s_linear_infinite]" style={{
        willChange: "background-position"
      }} />
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-background via-background/80 to-transparent pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center h-full py-20">
        {}
        <div className={`flex flex-col gap-8 max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
          <div className="space-y-2">
            <span className="text-secondary font-mono text-sm tracking-widest uppercase pl-1">
              StrideVault Exclusive
            </span>
            <h1 className="font-sans text-6xl sm:text-7xl lg:text-8xl font-extrabold tracking-tighter leading-[0.9]">
              <span className="bg-gradient-to-br from-white to-gray-500 bg-clip-text text-transparent block">
                STEP INTO
              </span>
              <span className="bg-gradient-to-br from-white via-gray-300 to-gray-600 bg-clip-text text-transparent block">
                THE FUTURE
              </span>
            </h1>
          </div>

          <p className="text-muted-foreground text-lg sm:text-xl max-w-lg leading-relaxed border-l-2 border-primary/30 pl-6">
            Experience the next evolution of athletic performance. Precision-engineered footwear designed for those who refuse to compromise on style or speed.
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-none skew-x-[-10deg] hover:skew-x-0 transition-transform duration-300">
              <Link to="/limited-drops">
                <span className="skew-x-[10deg] hover:skew-x-0 inline-flex items-center gap-2 font-bold uppercase tracking-wide">
                  Shop the Collection <ArrowRight className="size-5" />
                </span>
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="border-white/20 text-white hover:bg-white/10 text-lg h-14 px-8 rounded-none skew-x-[-10deg] hover:skew-x-0 transition-transform duration-300 backdrop-blur-sm">
              <Link to="/shoe-tech-size-guide">
                <span className="skew-x-[10deg] hover:skew-x-0 font-bold uppercase tracking-wide">
                  Explore Tech
                </span>
              </Link>
            </Button>
          </div>

          {}
          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/10 mt-4">
            <div>
              <p className="text-2xl font-bold text-white">0.02s</p>
              <p className="text-xs text-muted-foreground uppercase tracking-wider">Response Time</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-white">100%</p>
              <p className="text-xs text-muted-foreground uppercase tracking-wider">Carbon Fiber</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-white">Ltd.</p>
              <p className="text-xs text-muted-foreground uppercase tracking-wider">Edition Drop</p>
            </div>
          </div>
        </div>

        {}
        <div className={`relative flex justify-center items-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-secondary/20 blur-[100px] rounded-full pointer-events-none animate-pulse" />
          
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] border border-secondary/30 rounded-full opacity-50" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] border border-dashed border-white/10 rounded-full animate-[spin_20s_linear_infinite]" />

          {}
          <div className="relative z-10 animate-[float_6s_ease-in-out_infinite] hover:scale-105 transition-transform duration-500 cursor-pointer">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1564626/img/hero_sneaker_3d.png" alt="Flagship StrideVault Sneaker 3D Render" className="w-full max-w-[600px] h-auto object-contain drop-shadow-2xl" style={{
            filter: "drop-shadow(0 20px 30px rgba(0,0,0,0.5))"
          }} />
            
            {}
            <div className="absolute top-[30%] right-[20%] flex items-center gap-2">
              <div className="size-3 bg-primary rounded-full animate-ping absolute" />
              <div className="size-3 bg-primary rounded-full relative" />
              <div className="bg-black/80 backdrop-blur-md text-xs px-2 py-1 rounded border border-white/10 text-white whitespace-nowrap">
                Air-Mesh Upper
              </div>
            </div>
            
            <div className="absolute bottom-[25%] left-[20%] flex items-center gap-2 flex-row-reverse">
              <div className="size-3 bg-secondary rounded-full animate-ping absolute" />
              <div className="size-3 bg-secondary rounded-full relative" />
              <div className="bg-black/80 backdrop-blur-md text-xs px-2 py-1 rounded border border-white/10 text-white whitespace-nowrap">
                Reactive Sole
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(2deg); }
        }
        @keyframes background-scroll {
          0% { background-position: 0 0; }
          100% { background-position: 100% 100%; }
        }
      `}</style>
    </section>;
}